import { View, Text } from 'react-native'
import React from 'react'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import Button from '@app/sharedComponents/Button/Button'
import SystemWarning from '@app/assets/svg/SystemWarning'
import { useTheme } from '@shopify/restyle'

const BankErrorModal = ({ onPress , errorMessage }: { onPress: () => void , errorMessage?: string }) => {

  const { colors } = useTheme<Theme>()
  return (
    <ThemedView padding='lg' paddingTop='2xl' justifyContent='center' alignItems='center'>
      <SystemWarning color={colors['icon-error']} size={48} />
      <ThemedView mt='2xl' mb='sm'>
        <ThemedText textAlign='center' variant='h5s' color='text-primary'>Invalid bank account</ThemedText>
      </ThemedView>
      <ThemedView alignSelf='stretch' backgroundColor='bg-fill-warning' padding='md' borderRadius='sm' mb='2xl'>
        <ThemedText textAlign='center' variant='b3r' color='text-primary'>{errorMessage ?? 'We couldn\'t verify this bank account, edit bank details and try again'}</ThemedText>
      </ThemedView>

      <Button size='MD' label='Add another bank account' handlePress={onPress} bg='#1434CB' textColor='text-primary' />
    </ThemedView>
  )
}

export default BankErrorModal